var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-field-opt panel-field-opt-select" },
    [
      _c("label", { staticClass: "contactum-label" }, [
        _vm._v(" " + _vm._s(_vm.field.title) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-select",
        {
          style: { width: "100%" },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        _vm._l(_vm.field.options, function(option, key) {
          return _c("el-option", {
            key: key,
            attrs: { label: option, value: key }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }